<script lang="ts">
    import DesignFeedClapIcon from "@apps/iloom_customization/design_feed/components/icons/DesignFeedClapIcon.svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    export let didViewerReact: boolean;
    export let disabled = false;
</script>

<BaseButton {disabled} class="gw-df-reaction-button" on:click>
    {#if didViewerReact}
        完全的
    {:else}
        我想買 <DesignFeedClapIcon />
    {/if}
</BaseButton>

<style lang="postcss">
    :global(.gw-btn.gw-df-reaction-button) {
        height: 36px;
        padding: 6px 12px;
        display: flex;
        align-items: center;
        gap: 6px;
        border: 1px solid #3c3c3c;
        border-radius: 30px;
        color: #3c3c3c;
        font-size: 12px;
        font-weight: 400;
        font-family: "Noto Sans TC";
        line-height: 1.4;
        transition: all 0.3s ease;

        &:hover {
            background-color: #3c3c3c;
            color: #fff;
        }

        &:disabled {
            border: 1px solid #f0f0f0;
            background-color: #f0f0f0;
            color: #9a9a9a;
            cursor: auto;
        }

        :global(.gw-df-clap-icon) {
            font-size: 24px;
        }

        @media all and (max-width: 600px) {
            height: 28px;
            padding: 2px 6px;
            font-size: 10px;
            :global(.gw-df-clap-icon) {
                font-size: 16px;
            }
        }
    }
</style>
